import { render, staticRenderFns } from "./ShopRouter_my_mobile.vue?vue&type=template&id=80fd3762&scoped=true"
import script from "./ShopRouter_my_mobile.vue?vue&type=script&lang=js"
export * from "./ShopRouter_my_mobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80fd3762",
  null
  
)

export default component.exports